import React, { useEffect, useState } from "react";
import {
  verifyLogin,
  getToken,
  getAccountId,
} from "../../Components/utilities/authHelper";
import { getEnvironmentId } from "@seahorse/api";
import { fetchSubscriptions } from "../Utils/Utils";
import SubscriptionCheck from "../Wrapper/SubscriptionCheck";
import { CircularProgress } from "@seahorse/ui";
import { getGlSsoLoginUrl, resolveGlSsoEnvironment } from "./glSsoConfig.mjs";

export const fetchUserData = async (setLoading, setUserProfile, setError) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    setLoading(true);
    const response = await fetch(`${apiUrl}/auth:current`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setUserProfile(data.results);
  } catch (error) {
    console.error("Error fetching user data:", error);
    setError(true);
  } finally {
    setLoading(false);
  }
};

const GLPRotectedRoute = ({ children }) => {
  const configuredEnvironment = process.env.REACT_APP_GL_ENV;
  const configuredApiUrl = process.env.REACT_APP_API_URL;
  const [, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [environment, setEnvironment] = useState(null);
  const [environmentError, setEnvironmentError] = useState(false);
  const [userSubscription, setUserSubscription] = useState(null);
  const [subscriptionLoading, setSubscriptionLoading] = useState(true);
  const isAuthenticated = verifyLogin();
  const accountId = getAccountId();
  const originalUrl = window.location.href;
  const iframeName = window.name || "default";
  sessionStorage.setItem(`start_page_${iframeName}`, originalUrl);

  useEffect(() => {
    let cancelled = false;
    const getEnvironment = async () => {
      try {
        let env = resolveGlSsoEnvironment(configuredEnvironment, null);
        if (!env) {
          env = resolveGlSsoEnvironment(null, await getEnvironmentId());
        }
        if (!cancelled) {
          if (env) {
            setEnvironment(env);
          } else {
            setEnvironmentError(true);
          }
        }
      } catch {
        if (!cancelled) {
          setEnvironmentError(true);
        }
      }
    };

    getEnvironment();
    return () => {
      cancelled = true;
    };
  }, [configuredEnvironment]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchUserData(setLoading, setUserProfile, setError);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchSubscriptions(setUserSubscription, setSubscriptionLoading);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!environment || environmentError || (isAuthenticated && !error)) {
      return;
    }
    try {
      window.location.href = getGlSsoLoginUrl(environment, configuredApiUrl);
    } catch {
      setEnvironmentError(true);
    }
  }, [environment, environmentError, isAuthenticated, error, configuredApiUrl]);

  if (environmentError) {
    return <div role="alert">Unable to start sign-in. Please refresh and try again.</div>;
  }

  const waitingForLogin = !environment || !isAuthenticated || error;
  return (
    <>
      {waitingForLogin || loading || subscriptionLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          {userSubscription?.length > 0 ? (
            children
          ) : (
            <SubscriptionCheck accountId={accountId} />
          )}
        </>
      )}
    </>
  );
};

export default GLPRotectedRoute;
